import React,{useState} from 'react'
import Facts from './Facts'
import Validate from './Validate'
import Generate from './Generate'
import Decision from './Decision'
import { useDispatch } from 'react-redux';
export default function Main({ viewdata,handleView}) {
    const [tabview,setTabView] =useState("facts")
    const dispatch = useDispatch();

    const handleTabs = (type)=>{
        if (tabview === 'validate' && type !== 'validate') {
            dispatch({ type: 'CLEAR_VALIDATION_RESULTS' });
        }
        setTabView(type)
    }
  return (
    <>
        <div className="container-fluid" style={{padding:'0 40px'}}>
            <h4 style={{display:'inline-block',cursor:'pointer'}} onClick={()=>handleView("list")}><i class="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;{viewdata.ruleName}</h4>

            <div className="TabsSection">
                <div className={`tab ${tabview === "facts" ? "active" : ''}`} onClick={(e)=>handleTabs("facts")}>Facts</div>
                <div className={`tab ${tabview === "decision" ? "active" : ''}`} onClick={(e)=>handleTabs("decision")}>Decision</div>
                <div className={`tab ${tabview === "validate" ? "active" : ''}`} onClick={(e)=>handleTabs("validate")}>Validate</div>
                <div className={`tab ${tabview === "generate" ? "active" : ''}`} onClick={(e)=>handleTabs("generate")}>Generate</div>
            </div>

            {
                tabview === "facts" ?
                <Facts />
            :''}
            {
                tabview === "decision" ?
                <Decision />
            :''}
            {
                tabview === "validate" ?
                <Validate />
            :''}
            {
                tabview === "generate" ?
                <Generate />
            :''}
        </div>
    </>
  )
}
